export const QA_ENV_URBAN_DEFAULT_SETTINGS = {
    defaultIcon: 'https://mirage-orbit-latest-eu.888casino.com/configurations/888casino_com/assets/images/888casinologo.png',
    defaultTitle: '888Casino',
    defaultActionURL: 'https://mirage-orbit-latest-eu.888casino.com',
    appKey: '64FbuTbIS9aQUIwB0cWoMA',
    token: 'MTo2NEZidVRiSVM5YVFVSXdCMGNXb01BOkFVRXNxa2hEUE5rZUtTOW1DLVdvR3hwMHNjdHEtNF9xLXJ1M3ZGazVJWEU',
    vapidPublicKey: 'BJOvGd2nCaeEGqqKnsJJhWmJzMvJqO4t3wSCqzVJ6uhHWw3891tqJhs8muo958dtbggZe4vM122EtKE9HkvUf9U='
};

export const PWA_PROMPT_EVENT = "pwaPromptEvent";
export const PWA_PROMPT_CALLBACK = "pwaPromptCallback";
export const PWA_INSTALLED_CALLBACK = "pwaInstalledCallback";
export const PWA_SHOULD_AUTO_POPUP_LOCAL_STORAGE_KEY = "orbit-pwa-should-auto-popup";
export const PWA_IOS_SHOWN_INSTALL_OFFER_COUNT = "orbit-pwa-ios-shown-install-tooltip-count";
